import { SxProps } from '@mui/material'

interface FullscreenLoaderStyles {
  dialog: SxProps
  container: SxProps
  logo: SxProps
}

export const fullscreenLoaderStyles: FullscreenLoaderStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      boxShadow: 'none',
    },
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  logo: {
    width: 180,
    height: 'auto',
    display: 'block',
  },
}
